import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINT } from "../../../config/config";

const initialState = {
  loading: false,
  count: 0,
  next: null,
  previous: null,
  currentPage: 1,
  limit: 10000,
  offset: 0,
  results: [],
  search: "",
  position: [],
};

const buildPositionParam = (position = []) =>
  position.length ? position.map((p) => `position=${p}`).join("&") : "";

export const getDraftRoomV2Players = createAsyncThunk(
  "draftRoomV2Players/getDraftRoomV2Players",
  async (_, { dispatch, getState, rejectWithValue }) => {
    try {
      const {
        draftRoomV2Players: { limit, search, position },
      } = getState();
      const offset = 0;
      const positionParam = buildPositionParam(position);
      const res = await axios.get(
        `${API_ENDPOINT}players/?limit=${limit}&offset=${offset}&search=${search}&${positionParam}`
      );
      dispatch(
        setDraftRoomV2Players({
          ...res.data,
          limit,
          search,
          position,
          currentPage: 1,
          offset,
        })
      );
    } catch (error) {
      return rejectWithValue(error?.message || "Fetch error");
    }
  }
);

export const draftRoomV2PlayersSlice = createSlice({
  name: "draftRoomV2Players",
  initialState,
  reducers: {
    setDraftRoomV2Players: (state, action) => {
      Object.assign(state, action.payload);
    },
    setDraftRoomV2Search: (state, action) => {
      state.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDraftRoomV2Players.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDraftRoomV2Players.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getDraftRoomV2Players.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const selectDraftRoomV2Players = (state) => state.draftRoomV2Players;

export const { setDraftRoomV2Players, setDraftRoomV2Search } = draftRoomV2PlayersSlice.actions;

export default draftRoomV2PlayersSlice.reducer;
